import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import {
  getRequiredFields,
  removeEmptyFields,
  setEmptyFieldsToNull,
} from "@/lib/utils";
import {
  NAME,
  CATEGORY,
  PRIORITY,
  TERM,
  ASSIGN_TO,
  START_DATE,
  ROLE,
  SCHOOL,
  TASK_STATUS,
} from "../consts";
import { useIsMobile } from "@/hooks/use-mobile";
import { formValues, schema } from "./validations";
import { useEffect } from "react";

const useFilter = ({
  filterData,
  setFilterData,
  onApply,
  onCancel,
}: {
  filterData: any;
  setFilterData: React.Dispatch<React.SetStateAction<any>>;
  onApply?: (filterData: any) => void;
  onCancel: () => void;
}) => {
  const isMobile = useIsMobile();

  const form = useForm<formValues>({
    resolver: zodResolver(schema),
    defaultValues: {
      [NAME]: "",
      [CATEGORY]: "",
      [PRIORITY]: "",
      [START_DATE]: "",
      [TASK_STATUS]: "",
      [SCHOOL]: "",
      [ROLE]: "",
      [ASSIGN_TO]: "",
    },
  });

  useEffect(() => {
    if (filterData) {
      form.reset({
        [NAME]: filterData?.[NAME] || "",
        [CATEGORY]: filterData?.[CATEGORY] || "",
        [PRIORITY]: filterData?.[PRIORITY] || "",
        [START_DATE]: filterData?.[START_DATE] || "",
        [TASK_STATUS]: filterData?.[TASK_STATUS] || "",
        [SCHOOL]: filterData?.[SCHOOL] || "",
        [ROLE]: filterData?.[ROLE] || "",
        [ASSIGN_TO]: filterData?.[ASSIGN_TO] || "",
      });
    }
  }, [filterData]);

  const requiredFields = getRequiredFields(schema);

  const onSubmit = (data: formValues) => {
      let _data = removeEmptyFields(data);
      _data = setEmptyFieldsToNull(data);
      setFilterData(_data);
      if (onApply) {
        onApply(_data);
      }
      onCancel();
    };


  const onClear = () => {
    setFilterData(null);
    form.reset({
      [NAME]: "",
      [CATEGORY]: "",
      [PRIORITY]: "",
      [START_DATE]: "",
      [TASK_STATUS]: "",
      [SCHOOL]: "",
      [ROLE]: "",
      [ASSIGN_TO]: "",
    }) 
  };

  return {
    form,
    onSubmit,
    requiredFields,
    isMobile,
    onClear,
  };
};

export default useFilter;
